import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import * as Components from './imports/components'
import { AuthGuard } from './guards/auth.guard'
import { LoginGuard } from './guards/login.guard'

const routes: Routes = [
  { path: "", component: Components.HomeComponent, canActivate: [AuthGuard] },
  { path: "transaction", component: Components.TransactionsComponent, canActivate: [AuthGuard] },
  { path: "login", component: Components.LoginComponent },
  { path: "notFound", component: Components.PageNotFoundComponent },
  { path: "intro", component: Components.IntroComponent },
  { path: "features", component: Components.FeaturesComponent },
  { path: "about", component: Components.AboutComponent },
  { path: "openai", component: Components.OpenAiComponent, canActivate: [AuthGuard] },
  { path: "exchange", component: Components.CurrencyConvertorComponent, canActivate: [AuthGuard] },
  { path: "goals", component: Components.GoalsComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: 'notFound' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
